const regexes = {
  uppercase: /([A-Z]+)/,
  downcase: /([a-z]+)/,
  specialChar: /([@#$!%*?&]+)/,
  number: /([0-9]+)/,
}

export default regexes
